import { SearchQueryOrderDirection } from "types/generated";

export enum IdpGroupFilterItemKeys {
  GroupId = "groupId",
  Users = "members",
  IdentityProvider = "identityProvider",
  LastLogin = "lastLogin",
  Status = "status",
}

export const INITIAL_SORT_OPTION = IdpGroupFilterItemKeys.GroupId;
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Asc;

export const FILTERS_ORDER_SETTINGS_KEY = "idpGroupMappingFiltersOrderV2";
